import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import { default as BaseButton } from '../../../BaseComponents/Button';

interface Props {
	onClick: () => void;
}

const EmptyDatesOverlay: React.FC<Props> = props => {
	const { SearchFormDatepickerStyles: css } = useTheme('SearchFormDatepicker');
	const { t } = useTranslation('SearchFormDatepicker');

	const { onClick } = props;

	return (
		<Backdrop open={true} classes={{ root: css.overlay }}>
			<h5 className={css.overlay__title}>{t('Oops')} :(</h5>
			<p className={css.overlay__msg}>
				{t('Something went wrong, please check your internet connection or come back later')}
			</p>
			<BaseButton variant="optionAction" classes={{ root: css.overlay }} onClick={onClick}>
				{t('Ok')}
			</BaseButton>
		</Backdrop>
	);
};

export default EmptyDatesOverlay;
